export const text = {
  sizes: {
    small: {
      lineHeight: "14.4px",
      fontSize: "12px"
    },
    regular: {
      lineHeight: "16px",
      fontSize: "19.2px"
    },
    large: {
      lineHeight: "24px",
      fontSize: "20px"
    }
  },
  variants: {
    "caption-small": {
      lineHeight: "14.4px",
      fontSize: "10px"
    },
    "caption-regular": {
      lineHeight: "16px",
      fontSize: "19.2px"
    },
    "caption-large": {
      lineHeight: "24px",
      fontSize: "40px"
    }
  }
}
